<style scoped>
#app {
  /* position: fixed; */
  top: 0;
  height: 100%;
  width: 100%;;
  /* overflow-y: auto; */
}
</style>

<template>
  <div id="app" v-if="loaded" :style="'background: #ecf0f1'">
    <dr-alert
      class="main-modal"
      :title="getAlert.title"
      :body="getAlert.body"
      :size="getAlert.size"
      :active="getAlert.active"
      :callback="getAlert.callback"
    />

    <dr-confirm
      class="main-modal"
      :title="getConfirm.title"
      :body="getConfirm.body"
      :footer="getConfirm.footer"
      :size="getConfirm.size"
      :active="getConfirm.active"
      :confirmText="getConfirm.confirmText"
      :beforeClose="getConfirm.beforeClose"
      :callback="getConfirm.callback"
      :cancelText="getConfirm.cancelText"
    />

    <update-password
      v-if="passwordChange"
      :next-route="$route.path"
    />

    <office-select-session v-if="offices.length > 0" />

    <transition mode="out-in" name="fade">
      <progress
        v-if="showProgress"
        class="progress global"
        max="100"
      />
    </transition>

    <transition mode="out-in" name="fade">
      <router-view :reset-password.sync="passwordChange" />
    </transition>

    <upgrade-plan />
  </div>
</template>

<script>
import Alert from '@/components/modals/alert.vue'
import Confirm from '@/components/modals/confirm'
import updatePassword from '@/components/modals/updatePassword'
import officeSelectSession from '@/components/layout/setOffice/officeSelectSession'
import upgradePlan from '@/components/modals/upgradePlan'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    'dr-alert': Alert,
    'dr-confirm': Confirm,
    updatePassword,
    officeSelectSession,
    upgradePlan
  },
  data () {
    return {
      loaded: false,
      passwordChange: false,
      nextRoute: null
    }
  },
  computed: {
    ...mapGetters({
      offices: 'getOffices'
    }),

    getAlert () {
      return this.$store.getters.getAlert
    },
    getConfirm () {
      return this.$store.getters.getConfirm
    },
    showProgress () {
      return this.$store.getters.showProgress
    }
  },
  created () {
    // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
    // this.$moment.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone)
    this.$moment.tz.setDefault('America/Sao_Paulo')

    this.$store.dispatch('setModalAlert')
    this.$store.dispatch('setCancelToken', this.$http.CancelToken.source())
    /* this.$http.interceptors.response.use(function (config) {
      this.fn_SHOW_PROGRESS()
      return config
    }, function (error) {
      return Promise.reject(error)
    }) */
    // if (!this.fn_CHECK_AUTH()) {
    //   this.$router.replace('/')
    // }
    this.loaded = true
    const self = this
    let callStack = 0
    this.$http.interceptors.request.use(config => {
      callStack++
      self.$store.dispatch('setCallStack', callStack)
      if (config.method === 'get' || config.method === 'GET') {
        if (config.url.indexOf('in_progress') > -1 || config.url.indexOf('tour') > -1 || config.url.indexOf('versions') > -1) {
          return config
        } else {
          config.cancelToken = this.$store.getters.getCancelToken.token
        }
      }
      return config
    })
    this.$http.interceptors.response.use(function (response) {
      callStack--
      self.$store.dispatch('setCallStack', callStack)
      return response
    }, function (error) {
      callStack--
      self.$store.dispatch('setCallStack', callStack)
      if (error.response) {
        switch (error.response.code || error.response.status) {
          case (503):
            self.$router.replace('/maintenance')
            self.$store.dispatch('setCallStack', 0)
            return
          case (401):
            if (error.response.config.headers['Accept-Language'] !== 'cancelAccount') {
              self.$store.dispatch('setModalAlert', {
                title: 'Erro de autenticação',
                body: 'Seu acesso expirou. Por favor realize o login novamente',
                size: 'md',
                active: true,
                callback (next) {
                  this.fn_HIDE_PROGRESS()
                  this.$store.dispatch('clearAuth')
                  this.$router.push({path: '/login'})
                }
              })
            }
            break
          // case (403):
          //   if (error.response.data.indexOf('plano') > -1) {
          //     self.$store.dispatch('setModalAlert', {
          //     title: 'Planos de assinatura',
          //     body: error.response.data,
          //     size: 'md',
          //     active: true
          //   })
          //   }
          //   break
          case (404):
            break
          case (424):
            return Promise.reject(error)
          case (400):
            if (error.response.data.type === 'resetPassword') {
              self.passwordChange = true
              return Promise.reject(error.response.data.msg)
            }
        }
        return Promise.reject(error.response.data)
      }
      if (error.type === 'resetPassword') {
        self.passwordChange = true
        return
      }
      return Promise.reject(error.message || error)
    })
  }
}
</script>

<style lang="scss">
@import "assets/styles/main";

body {
  background-color: #fff;
}
</style>
